import React, { Component } from 'react';
import BaseLayout from '../../templates/base';

class Dashboard extends Component {
	render() {
		return <div>Dashboard</div>
	}
}

export default BaseLayout(Dashboard, {title: 'Dashboard', subnav: {}})


// WEBPACK FOOTER //
// ./src/layouts/dashboard/index.jsx